export default "__VITE_ASSET__BKLdEgKY__"